import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';
import { ErrorService } from '../../../services/error.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @Input() profile: any;

  constructor(
    private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly router: Router,
    public errorService: ErrorService
  ) {
    // propagate auth errors
    this.authService.authErrorMessage$
      .asObservable()
      .subscribe((error) => this.errorService.errorMessage$.next(error));
  }

  ngOnInit(): void {
    // if not logged in → go to login page
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['login']);
    }
  }

  logout(): void {
    this.userService.user = null;
    this.authService.logout();
  }
}
